(function () {
  if (window.__readSirahNavInitialized) return;
  window.__readSirahNavInitialized = true;

  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  const pathName = window.location.pathname;
  const normalizedPath = pathName.replace(/\/+$/, '') || '/';
  const isHome = normalizedPath === '/' || normalizedPath === '/index.html';
  const homeHref = window.location.protocol === 'file:' ? 'index.html' : '/';

  // Keep iOS Safari's status bar / Dynamic Island tint in sync with the nav.
  const themeColorMeta = document.getElementById('rs-theme-color') || document.querySelector('meta[name="theme-color"]');
  const COLOR_DARK = '#120802';
  const COLOR_PARCHMENT = '#F6EDD5';
  const setStatusColor = (color) => {
    if (themeColorMeta && themeColorMeta.getAttribute('content') !== color) {
      themeColorMeta.setAttribute('content', color);
    }
    document.documentElement.style.setProperty('--rs-safe-bg', color);
  };

  // Transparent → glass transition: triggers at 82% of viewport height (past the hero)
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY > window.innerHeight * 0.82;
    headerWrapper.classList.toggle('scrolled', scrolled);
    if (isHome) setStatusColor(scrolled ? COLOR_PARCHMENT : COLOR_DARK);
  }, { passive: true });

  // Non-home pages always show the glass background
  if (!isHome) {
    headerWrapper.classList.add('scrolled');
    setStatusColor(COLOR_PARCHMENT);
  } else {
    // Home initial state: dark over the hero
    setStatusColor(COLOR_DARK);
  }

  const headerEl = document.querySelector('.header');
  const iconsEl = headerEl && headerEl.querySelector('.header__icons');
  if (!headerEl || !iconsEl) return;

  const NAV_ITEMS = [
    { href: '#story',          label: 'Story' },
    { href: '#panels',         label: 'Inside' },
    { href: '#shop',           label: 'Shop' },
    { href: '/pages/about',    label: 'About' },
    { href: '/pages/our-sources', label: 'Sources' },
    { href: '#join',           label: 'Join' },
  ];

  const drawerList = document.querySelector('.menu-drawer__menu.list-menu');
  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  if (drawerList) {
    // Clear whatever Shopify dropped in (the main-menu items) so we can
    // rebuild the drawer fresh from NAV_ITEMS — keeps mobile drawer in
    // lockstep with the desktop rs-header-nav-links.
    drawerList.innerHTML = '';
    if (isHome) {
      [...NAV_ITEMS, { href: '#shop', label: 'Order Now' }].forEach(({ href, label }) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = href;
        a.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset';
        a.textContent = label;
        a.addEventListener('click', (e) => {
          if (href.startsWith('#')) {
            e.preventDefault();
            if (drawerDetails) {
              drawerDetails.removeAttribute('open');
              drawerDetails.classList.remove('menu-opening');
            }
            document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');
            const sectionHeader = document.querySelector('.section-header');
            if (sectionHeader) sectionHeader.classList.remove('menu-open');
            const target = document.querySelector(href);
            if (target) setTimeout(() => target.scrollIntoView({ behavior: 'smooth' }), 150);
          }
        });
        li.appendChild(a);
        drawerList.appendChild(li);
      });
    } else {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = homeHref;
      a.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset';
      a.textContent = 'Back to Home';
      li.appendChild(a);
      drawerList.appendChild(li);
    }
  }

  if (isHome) {
    // Section anchor links (desktop) — absolutely centered
    const navLinks = document.createElement('div');
    navLinks.className = 'rs-header-nav-links';
    NAV_ITEMS.forEach(({ href, label }) => {
      const a = document.createElement('a');
      a.className = 'rs-header-nav-link';
      a.href = href;
      a.textContent = label;
      navLinks.appendChild(a);
    });

    // Order Now CTA button (desktop right side)
    const ctaBtn = document.createElement('a');
    ctaBtn.className = 'rs-header-cta';
    ctaBtn.href = '#shop';
    ctaBtn.textContent = 'Order Now';

    headerEl.insertBefore(ctaBtn, iconsEl);
    headerEl.insertBefore(navLinks, ctaBtn);
  } else {
    // Back to Home on all other pages
    const backLink = document.createElement('a');
    backLink.className = 'rs-header-back';
    backLink.href = homeHref;
    backLink.textContent = 'Back to Home';
    headerEl.insertBefore(backLink, iconsEl);
  }
})();
